import React, { FC, useMemo } from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import cx from 'classnames';
import parse from 'html-react-parser';

import { HEADER_IMG_SRC_SET } from '../../const';
import {
  LearnerInfo,
  ContactFormBlock as ContactFormBlockType,
  ContactFormItem,
} from '../../types';
import useCommonStyles from '../../utils/commonStyles';
import useTextStyles from '../../utils/textStyles';
import IKImage from '../IKImage/IKImage';
import { ContactForm } from './ContactForm';
import useStyles from './styles';

interface ContactFormBlockProps {
  data: ContactFormBlockType;
  userInfo?: LearnerInfo;
}

const ContactFormBlock: FC<ContactFormBlockProps> = ({ data: blockData, userInfo }) => {
  const background = blockData?.background;
  const heading = blockData?.heading;
  const classes = useStyles(background)();
  const textClasses = useTextStyles();
  const commonClasses = useCommonStyles();

  const reasonItems: ContactFormItem[] = useMemo(() => {
    return blockData?.items
      ? (blockData.items.filter((item) => Boolean(item)) as ContactFormItem[])
      : [];
  }, [blockData]);

  return (
    <Box className={cx(classes.wrapper, 'contact-form-block')}>
      {blockData?.background_image && (
        <div className={classes.bgImageWrapper}>
          <IKImage
            className={classes.bgImage}
            path={blockData?.background_image}
            alt={heading}
            srcset={HEADER_IMG_SRC_SET}
            sizes="100vw"
            draggable={false}
          />
        </div>
      )}
      <Container className={classes.container}>
        <div className={classes.content}>
          <Typography variant="h1" className={cx(textClasses.h1, classes.heading)}>
            {blockData?.heading}
          </Typography>
          <div
            data-testid="subtitle"
            className={cx(commonClasses.reachText, textClasses.bodyIntro, classes.subtitle)}
          >
            {Boolean(blockData?.sub_title) && parse(blockData.sub_title as string)}
          </div>
          <ContactForm
            userName={userInfo?.name}
            userEmail={userInfo?.email}
            reasonItems={reasonItems}
            userComFormId={blockData?.user_com_formId}
            nameField={blockData?.name_field}
            emailField={blockData?.email_field}
            contactReasonField={blockData?.contact_reason_field}
            contactMessageField={blockData?.contact_message_field}
          />
        </div>
      </Container>
    </Box>
  );
};

export default ContactFormBlock;
